import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/lib/i18n";

const LanguageContext = createContext(null);

const SUPPORTED = new Set(["es", "en", "ca"]);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      const stored = localStorage.getItem("reforma_lang") || "es";
      return SUPPORTED.has(stored) ? stored : "es";
    } catch {
      return "es";
    }
  });
  // Keep <html lang="..."> in sync with the active UI language so screen readers
  // pronounce content with the right phonetics and browser autotranslate behaves.
  useEffect(() => {
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);
  const set = (l) => {
    const next = SUPPORTED.has(l) ? l : "es";
    try { localStorage.setItem("reforma_lang", next); } catch { /* blocked */ }
    setLang(next);
  };
  const t = translations[lang] || translations.es;
  return (
    <LanguageContext.Provider value={{ lang, setLang: set, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useI18n = () => useContext(LanguageContext);
